import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-mobile-menu',
    templateUrl: './app-mobile-menu.component.html'
})
export class AppMobileMenuComponent {
    @Input()
    public navigationItems: Backend.PortalMenuFirstLevelMenuItem[] = [];
    public activeNavigationItem: Backend.PortalMenuFirstLevelMenuItem = null;

    public closeMobileMenu(): void {
        document.documentElement.classList.remove('menu-mobile-open');
    }
}
